import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';

export default function getAllAttendees(formId: string): EmailAddressWrapper[] {
    const event = getComposeEvent(formId);
    if (!event) {
        return [];
    }
    return [
        ...(event.RequiredAttendees
            ? event.RequiredAttendees.map(attendee => attendee.Mailbox)
            : []),
        ...(event.OptionalAttendees
            ? event.OptionalAttendees.map(attendee => attendee.Mailbox)
            : []),
    ];
}
